import { render, staticRenderFns } from "./CalendarDay.vue?vue&type=template&id=fb2b66c4&scoped=true"
import script from "./CalendarDay.vue?vue&type=script&lang=js"
export * from "./CalendarDay.vue?vue&type=script&lang=js"
import style0 from "./CalendarDay.vue?vue&type=style&index=0&id=fb2b66c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b66c4",
  null
  
)

export default component.exports